import { v4 as UUID } from 'uuid';
import NodeBuilder from './NodeBuilder';
import { isSectionBlueprint, } from '../../../types/questionnaireBlueprints/questionnaireBlueprints';
export default class SectionGroupBuilder extends NodeBuilder {
    sectionGroupKey = null;
    constructor(seedProviders) {
        super(seedProviders.forSectionGroup());
        this.node.id = UUID();
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    withSectionGroupKey(sectionGroupKey) {
        this.sectionGroupKey = sectionGroupKey;
        return this.clone();
    }
    getSectionGroupKey() {
        return this.sectionGroupKey;
    }
    withPartName(partname) {
        this.node.partName = partname;
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    visibleIf(condition) {
        this.node.visible = condition;
        return this.clone();
    }
    repeatable(options) {
        this.node.repeatable = {
            repeatableAnswerNodeId: options.repeatableAnswerNodeId,
            minRepeatable: 1,
            maxRepeatable: 6,
        };
        return this.clone();
    }
    validate(section) {
        return isSectionBlueprint(section);
    }
}
